/***
 * @file:
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
/**
 * èåæ°æ®
 */
export class MenuData {
  // ID
  id: string;

  // ç¶ID
  parentId: string;

  // åç§°
  name: string;

  // å³é®å­
  keyWord: string;

  // å¾æ 
  icon: string;

  // æ¯å¦å±å¼
  isExpend?: boolean;

  // URL
  url?: string;

  // å­èç¹
  children?: Array<MenuData>;

  moduleId?: string;

  selectedId?: object;

  moduleName?: string;

  // æ¯å¦æå­èç¹
  hasChildren?: boolean;

  // èåèç¹é¡ºåº
  orderId?: string;

  flag?: string;

  moduleLevel?: string;

  ids?: string[];

  asMenu?: boolean;

  // è·¯ç±ä¸­çåæ°
  param: object;
}

export interface SelectedNode {
  moduleId?: string;
  parentId?: string;
  showChildren?: boolean;
  orderId?: string;
  flag?: string;
  level?: string;
}

export interface ValidMenu {
  router: string;
  moduleName: string;
  moduleNameEn: string;
}
